const REWARD_ITEM_TYPE = {
  COUPON: 1,
  OTHERS: 2,
  MENTORSHIP: 3
};

export default REWARD_ITEM_TYPE;
